import filter from 'lodash/filter';
import find from 'lodash/find';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import some from 'lodash/some';
export function isDealerLocatorPageEmpty(props) {
    return !props.googleApiKey || !props.countries.length;
}
export const getCategoryById = (categories, categoryId) => find(categories, {
    categoryId,
});
export const getCountriesCodes = (countries) => map(countries, ({ code }) => code.toLowerCase());
export const getCategoriesDDItems = (categories) => {
    return map(categories, ({ categoryId, categoryName }) => ({
        value: categoryId,
        label: categoryName,
    }));
};
export const getServicesDDItems = (services, selectedService, dealersForCategory) => {
    const existedServices = services?.filter((services) => dealersForCategory.some((dealer) => dealer.serviceIds.includes(services.serviceId)));
    return map(existedServices, ({ serviceName, serviceId }) => ({
        value: serviceId,
        label: serviceName,
        checked: includes(selectedService, serviceId),
    }));
};
export const sortFiltersItemsAlphabetical = (filters, locale = '') => {
    return filters?.sort((a, b) => a?.label?.localeCompare(b?.label, locale));
};
// filtering flow
export const isCategoryIncludesService = ({ services }, serviceId) => Boolean(find(services, {
    serviceId,
}));
export const filterDealers = (dealers, selectedCategory, selectedService) => {
    if (isEmpty(dealers)) {
        return [];
    }
    /**
     * category = any
     * services = null | filled
     */
    if (!selectedCategory) {
        return dealers;
    }
    /**
     * category = filled
     * services = null | filled
     */
    const dealersForCategory = filter(dealers, ({ serviceIds }) => some(serviceIds, (serviceId) => isCategoryIncludesService(selectedCategory, serviceId)));
    /**
     * category = filled
     * services = null | filled
     */
    if (isEmpty(selectedService)) {
        return dealersForCategory;
    }
    /**
     * category = filled
     * services = filled
     */
    return filter(dealersForCategory, ({ serviceIds }) => some(serviceIds, (serviceId) => includes(selectedService, serviceId)));
};
export const removeDistanceFromDealers = (dealers) => map(dealers, (dealer) => {
    dealer.distance = 0;
    return dealer;
});
export const fromCoordinatesToCoordinatesV2 = (coordinates) => ({
    latitude: coordinates.lat,
    longitude: coordinates.lng,
});
export const filterCategoriesForCountry = ({ categories, dealers, }) => {
    if (categories.length) {
        const isServiceExistForSomeDealer = (service) => dealers.some((dealer) => dealer.serviceIds.includes(service.serviceId));
        const isCategoryRelevant = (category) => category.services.some(isServiceExistForSomeDealer);
        return categories.filter(isCategoryRelevant);
    }
    return [];
};
